// Palet "Pastel Bouquet" — sesuai mockup di tiket Tulip DEV-1049 (screenshot-crm-inbox-reference.png,
// screenshot-set-label.png, screenshot-chat-final-country-code.png). D-8 pada tiket itu memutuskan
// TIDAK memakai skema warna WhatsApp (hijau) — jangan kembalikan warna hijau/biru default MUI di sini.
export const PASTEL = {
    primary: "#8c5b73",
    primaryDark: "#6f4459",
    primarySoft: "#f3e3ea",
    background: "#f6ece2",
    surface: "#fffdfb",
    surfaceAlt: "#faf3ec",
    border: "#ece0d5",
};

// Warna kanal per-brand meniru rail kanal di mockup (RB = mauve, Prestisa = mustard, Parselia = sage).
// Brand baru yang belum terdaftar di sini jatuh ke tone bernuansa sama lewat hash (lihat getBrandColor).
const BRAND_COLORS = {
    "Rangkaian Bunga": "#8c5b73",
    "Prestisa": "#c08a2e",
    "Parselia": "#6a8f6b",
};

const FALLBACK_BRAND_TONES = ["#8c5b73", "#c08a2e", "#6a8f6b", "#a1655a", "#6b7fa3"];

export function getBrandColor(brand = "") {
    if (BRAND_COLORS[brand]) return BRAND_COLORS[brand];
    let hash = 0;
    for (let i = 0; i < brand.length; i++) hash = brand.charCodeAt(i) + ((hash << 5) - hash);
    return FALLBACK_BRAND_TONES[Math.abs(hash) % FALLBACK_BRAND_TONES.length];
}
